import React, { useState } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import "./ScheduledPayout.css";
import cancel from "../../../../assests/cancel.svg";
import { Link } from "react-router-dom";
import filedownloadicon from "../../../../assests/filedonloadicon.svg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  IconButton,
  Popover
} from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';

const ScheduledPayoutComponent = ({
  loading,
  date,
  bills,
  selectedBills,
  totalAmount,
  onCheckboxChange,
  onSelectAll,
  onMarkSettled,
  onGoBack,
  apiResponse,
  showSuccessDialog,
  onSuccessClose,
  showResponseDialog,
  setShowResponseDialog,
  fetchChargeBillSummery,
  chargeSummery,
  currentPayoutId,
  cohortTypeMapping,
  getCohortTypeDisplayName
}) => {
  const [showDeductionDetails, setShowDeductionDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCohortType, setSelectedCohortType] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  // Get unique cohort types from bills with their display names
  const cohortTypes = [...new Set(bills.map(bill => bill.cohortTypeId))].sort();

  // Filter bills based on search term and selected cohort type
  const filteredBills = bills.filter(bill => {
    const matchesSearch =
      bill.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      bill.franchiseeId?.toString().includes(searchTerm) ||
      bill.payoutId?.toString().includes(searchTerm) ||
      bill.cohortId?.toString().includes(searchTerm) ||
      bill.billId?.toString().includes(searchTerm);

    const matchesCohortType = !selectedCohortType || bill.cohortTypeId === selectedCohortType;

    return matchesSearch && matchesCohortType;
  });

  const handleDeductionClick = (payoutId, totalDeductions) => {
    if (totalDeductions > 0) {
      fetchChargeBillSummery(payoutId);
      setShowDeductionDetails(true);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(amount).replace('₹', '₹ ');
  };

  const totalTransactionalAmount = chargeSummery?.transactionalCharges?.reduce(
    (acc, charge) => acc + (charge.amount || 0),
    0
  ) || 0;

  const totalFixedAmount = chargeSummery?.fixedCharges?.reduce(
    (acc, charge) => acc + (charge.amount || 0),
    0
  ) || 0;

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleCohortTypeChange = (type) => {
    setSelectedCohortType(type);
    handleFilterClose();
  };

  const clearFilter = () => {
    setSelectedCohortType("");
    handleFilterClose();
  };

  const renderResponseTable = () => {
    if (!apiResponse) return null;

    return (
      <TableContainer component={Paper} style={{ marginTop: '20px', maxHeight: '400px', overflow: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Field</TableCell>
              <TableCell>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(apiResponse.status || {}).map(([key, value]) => (
              <TableRow key={`status-${key}`}>
                <TableCell component="th" scope="row" style={{ fontWeight: 600 }}>status.{key}</TableCell>
                <TableCell style={{ fontFamily: 'monospace' }}>
                  {typeof value === 'object' ? JSON.stringify(value) : value}
                </TableCell>
              </TableRow>
            ))}
            {(apiResponse || []).map((item, index) => (
              Object.entries(item).map(([key, value]) => (
                <TableRow key={`data-${index}-${key}`}>
                  <TableCell component="th" scope="row" style={{ fontWeight: 600 }}>data[{index}].{key}</TableCell>
                  <TableCell style={{ fontFamily: 'monospace' }}>
                    {typeof value === 'object' ? JSON.stringify(value) : value}
                  </TableCell>
                </TableRow>
              )
              )))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const openFilter = Boolean(filterAnchorEl);
  const filterId = openFilter ? 'cohort-type-filter-popover' : undefined;

  return (
    <div className="scheduled-payout-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Sidebar />
          <div className="scheduled-payout-content-wrapper">
            {/* Header Section */}
            <div className="scheduled-payout-header">
              <div className="header-left">
                <button
                  className="scheduled-payout-back-button"
                  onClick={onGoBack}
                >
                  ←
                </button>
                <h1 className="scheduled-payout-title">
                  Partner Payout for {new Date(date).toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </h1>
              </div>
              <div className="scheduled-select-all">
                <input
                  type="checkbox"
                  checked={selectedBills.length === filteredBills.length && filteredBills.length > 0}
                  onChange={(e) => onSelectAll(e, filteredBills)}
                />
                <span>Select All</span>
              </div>
            </div>

            {/* Search Section */}
            <div className="spayout-earch-filter-section" style={{ width: "300px", marginBottom: '15px' }}>
              <div className="payout-search-container">
                <TextField
                  label="Search by Name, Partner ID, Cohort ID"
                  variant="outlined"
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: '300px', }}
                  InputProps={{
                    style: { height: '40px' }
                  }}
                />
              </div>
            </div>

            {/* Table Section */}
            <div className="scheduled-payout-table-container">
              <table className="scheduled-payout-table">
                <thead>
                  <tr>
                    <th>Billing ID</th>
                    <th>Payout ID</th>
                    <th>Partner ID</th>
                    <th>Partner Name</th>
                    <th>Type</th>
                    <th>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        Cohort Type
                        <IconButton
                          size="small"
                          onClick={handleFilterClick}
                          style={{
                            padding: '2px',
                            color: selectedCohortType ? '#1976d2' : 'inherit'
                          }}
                        >
                          <FilterListIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </th>
                    <th>Cohort ID</th>
                    <th>Gross Sale</th>
                    <th>Total Deduction</th>
                    <th>Net Payout</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBills.map((bill, index) => (
                    <tr key={bill.payoutId}>
                      <td>
                        <div className="bill-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedBills.includes(bill.payoutId)}
                            onChange={() => onCheckboxChange(bill.payoutId)}
                          />
                          <Link to={`/home/configuration/partner/bills/details/${bill.billId}`}>Bill {bill.billId}</Link>
                        </div>
                      </td>
                      <td>{bill.payoutId}</td>
                      <td>{bill.franchiseeId}</td>
                      <td>{bill.name}</td>
                      <td>{bill.type}</td>
                      <td>{getCohortTypeDisplayName ? getCohortTypeDisplayName(bill.cohortTypeId) : bill.cohortTypeId || "N/A"}</td>
                      <td>{bill.cohortId}</td>
                      
                      <td>{formatCurrency(bill.revenueToday)}</td>
                      <td>
                        <span
                          style={{
                            color: bill.totalDeductions > 0 ? 'blue' : 'inherit',
                            textDecoration: bill.totalDeductions > 0 ? 'underline' : 'none',
                            cursor: bill.totalDeductions > 0 ? 'pointer' : 'default'
                          }}
                          onClick={() => handleDeductionClick(bill.payoutId, bill.totalDeductions)}
                        >
                          {formatCurrency(bill.totalDeductions)}
                        </span>
                      </td>
                      <td>{formatCurrency(bill.netPayable)}</td>
                      <td>
                        <span className={`status status-${bill.status.toLowerCase()}`}>
                          {bill.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                  {filteredBills.length === 0 && (
                    <tr>
                      <td colSpan="11" style={{ textAlign: 'center', padding: '20px' }}>
                        No records found matching your search criteria
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Cohort Type Filter Popover */}
            <Popover
              id={filterId}
              open={openFilter}
              anchorEl={filterAnchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: {
                  padding: '15px',
                  minWidth: '220px',
                  maxHeight: '400px',
                }
              }}
            >
              {/* Header */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
              }}>
                <div style={{ fontWeight: 'bold' }}>Filter by Cohort Type</div>
                <IconButton
                  size="small"
                  onClick={handleFilterClose}
                  style={{ padding: '2px' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>

              {/* Clickable List */}
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {cohortTypes.map((type) => {
                  const displayName = getCohortTypeDisplayName ? getCohortTypeDisplayName(type) : type;
                  const isSelected = selectedCohortType === type;

                  return (
                    <div
                      key={type}
                      onClick={() => {
                        handleCohortTypeChange(type);
                      }}
                      style={{
                        padding: '8px 10px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        backgroundColor: isSelected ? '#FFEEE0' : '#f9f9f9',
                        color: isSelected ? '#FF7A00' : '#333',
                        fontWeight: isSelected ? '600' : '400',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#FFF4E6'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isSelected ? '#FFEEE0' : '#f9f9f9'}
                    >
                      {displayName}
                    </div>
                  );
                })}
              </div>

              {/* Clear Button */}
              <div style={{
                marginTop: '15px',
                display: 'flex',
                justifyContent: 'flex-end'
              }}>
                <Button
                  onClick={clearFilter}
                  variant="outlined"
                  size="small"
                  disabled={!selectedCohortType}
                >
                  Clear
                </Button>
              </div>
            </Popover>


            {selectedBills.length > 0 && (
              <div className="table-footer">
                <div className="scheduled-total-amount">
                  Total Amount To Be Paid: {formatCurrency(totalAmount)}
                </div>
                <button
                  className="settle-button"
                  onClick={onMarkSettled}
                >
                  Schedule Settlement
                </button>
              </div>
            )}
          </div>

          {/* Deduction Details Dialog */}
          <Dialog
            open={showDeductionDetails}
            onClose={() => setShowDeductionDetails(false)}
            maxWidth="md"
            fullWidth
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <DialogTitle>
                {new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                (Payout ID {chargeSummery?.payoutId || "NA"})
              </DialogTitle>
              <IconButton onClick={() => setShowDeductionDetails(false)} style={{ marginRight: '16px' }}>
                <CloseIcon />
              </IconButton>
            </div>

            <DialogContent style={{ padding: '0 24px 24px' }}>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  <div style={{ border: "2px dashed #FFA500", padding: '20px', borderRadius: '8px' }}>
                    <div style={{ marginBottom: '20px', fontSize: '14px' }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div>
                          <strong>Partner Name:</strong> {chargeSummery?.name || 'N/A'} ({chargeSummery?.type || 'N/A'})<br />
                          <strong>Cohort ID:</strong> {chargeSummery?.cohortId || 'N/A'}
                        </div>
                        <div>
                          <strong>Partner ID:</strong> {chargeSummery?.franchiseeId || 'N/A'}<br />
                          <strong>Total VM:</strong> {chargeSummery?.vmCount || 'N/A'}
                        </div>
                      </div>
                    </div>

                    <h4 style={{ margin: '16px 0 8px', fontSize: '14px', fontWeight: 'bold' }}>Charge Summary (Transactional)</h4>
                    <TableContainer component={Paper} style={{ marginBottom: '20px', boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell style={{ fontWeight: 'bold' }}>Deduction ID</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {chargeSummery?.transactionalCharges?.map((charge) => (
                            <TableRow key={`transactional-${charge.id}`}>
                              <TableCell>{charge.id}</TableCell>
                              <TableCell>
                                {charge.chargeType === 'raas_fee' ? 'RAAS Fee(%)' :
                                  charge.chargeType === 'ps_fee' ? 'PS Fee(%)' :
                                    charge.chargeType}
                              </TableCell>
                              <TableCell align="right">{formatCurrency(charge.amount)}</TableCell>
                            </TableRow>
                          ))}
                          {(!chargeSummery?.transactionalCharges || chargeSummery.transactionalCharges.length === 0) && (
                            <TableRow>
                              <TableCell colSpan={3} align="center">No transactional charges</TableCell>
                            </TableRow>
                          )}
                          <TableRow style={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
                            <TableCell colSpan={2}>% Charge Total</TableCell>
                            <TableCell align="right">
                              {formatCurrency(totalTransactionalAmount)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <h4 style={{ margin: '16px 0 8px', fontSize: '14px', fontWeight: 'bold' }}>Charge Summary (Fixed)</h4>
                    <TableContainer component={Paper} style={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell style={{ fontWeight: 'bold' }}>Deduction ID</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                            <TableCell align="right" style={{ fontWeight: 'bold' }}>Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {chargeSummery?.fixedCharges?.map((charge) => (
                            <TableRow key={`fixed-${charge.id}`}>
                              <TableCell>{charge.id}</TableCell>
                              <TableCell>
                                {charge.chargeType === 'saas_ik' ? 'SAAS IK' :
                                  charge.chargeType === 'rental_ik' ? 'Rental IK' :
                                    charge.chargeType === 'misc_charge' ? 'Miscellaneous' :
                                      charge.chargeType}
                              </TableCell>
                              <TableCell align="right">{formatCurrency(charge.amount)}</TableCell>
                            </TableRow>
                          ))}
                          {(!chargeSummery?.fixedCharges || chargeSummery.fixedCharges.length === 0) && (
                            <TableRow>
                              <TableCell colSpan={3} align="center">No fixed charges</TableCell>
                            </TableRow>
                          )}
                          <TableRow style={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
                            <TableCell colSpan={2}>Fix Charge Total</TableCell>
                            <TableCell align="right">
                              {formatCurrency(totalFixedAmount)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <div
                      style={{
                        marginTop: "20px",
                        fontWeight: "bold",
                        fontSize: "16px",
                        textAlign: "left",
                        backgroundColor: "#f0f0f0",
                        padding: "15px",
                        borderRadius: "8px",
                      }}
                    >
                      Total Deduction (Transactional + Fixed) ={" "}
                      {formatCurrency(
                        (chargeSummery?.totalTransactionalDeductions || 0) +
                        (chargeSummery?.totalFixedDeductions || 0)
                      )}
                    </div>
                  </div>
                </>
              )}
            </DialogContent>
          </Dialog>

          {/* Success Dialog */}
          <Dialog
            open={showSuccessDialog}
            onClose={onSuccessClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: '12px',
                padding: '10px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                width: "370px"
              }
            }}
          >
            <DialogContent style={{ padding: '32px 14px' }}>
              <img width={100} style={{ marginBottom: "10px" }} src={filedownloadicon} alt="" />
              <h3 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '16px'
              }}>
                Successfully
              </h3>
              <p style={{
                marginBottom: '24px',
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                Payout Has Been Generated And<br />
                Downloaded Successfully<br /><br />
                <span style={{ color: '#14AE78' }}>
                  Please upload this file to Bank Portal<br />
                  to Process the Payout for Partners
                </span>
              </p>
              <Button
                onClick={onSuccessClose}
                variant="contained"
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  borderRadius: '8px',
                  padding: '10px 24px',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  boxShadow: 'none',
                  width: '100%',
                }}
              >
                Ok
              </Button>
            </DialogContent>
          </Dialog>
        </>
      )}
    </div>
  );
};

export default ScheduledPayoutComponent;